// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/crud/contact_read_status_crud_service_generated.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { ContactReadStatus } from "../../../entity/contact_read_status_pb";

/**
 * IndexContactReadStatusArgs メッセージ
 *
 * @generated from message service.IndexContactReadStatusArgs
 */
export class IndexContactReadStatusArgs extends Message<IndexContactReadStatusArgs> {
  /**
   * @generated from field: int32 offset = 1;
   */
  offset = 0;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<IndexContactReadStatusArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexContactReadStatusArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexContactReadStatusArgs {
    return new IndexContactReadStatusArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexContactReadStatusArgs {
    return new IndexContactReadStatusArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexContactReadStatusArgs {
    return new IndexContactReadStatusArgs().fromJsonString(jsonString, options);
  }

  static equals(a: IndexContactReadStatusArgs | PlainMessage<IndexContactReadStatusArgs> | undefined, b: IndexContactReadStatusArgs | PlainMessage<IndexContactReadStatusArgs> | undefined): boolean {
    return proto3.util.equals(IndexContactReadStatusArgs, a, b);
  }
}

/**
 * CreateContactReadStatusArgs メッセージ
 *
 * @generated from message service.CreateContactReadStatusArgs
 */
export class CreateContactReadStatusArgs extends Message<CreateContactReadStatusArgs> {
  /**
   * @generated from field: repeated entity.ContactReadStatus contact_read_statuss = 1 [json_name = "contact_read_statuss"];
   */
  contactReadStatuss: ContactReadStatus[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 3 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<CreateContactReadStatusArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateContactReadStatusArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contact_read_statuss", jsonName: "contact_read_statuss", kind: "message", T: ContactReadStatus, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateContactReadStatusArgs {
    return new CreateContactReadStatusArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateContactReadStatusArgs {
    return new CreateContactReadStatusArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateContactReadStatusArgs {
    return new CreateContactReadStatusArgs().fromJsonString(jsonString, options);
  }

  static equals(a: CreateContactReadStatusArgs | PlainMessage<CreateContactReadStatusArgs> | undefined, b: CreateContactReadStatusArgs | PlainMessage<CreateContactReadStatusArgs> | undefined): boolean {
    return proto3.util.equals(CreateContactReadStatusArgs, a, b);
  }
}

/**
 * ReadContactReadStatusArgs メッセージ
 *
 * @generated from message service.ReadContactReadStatusArgs
 */
export class ReadContactReadStatusArgs extends Message<ReadContactReadStatusArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<ReadContactReadStatusArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadContactReadStatusArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadContactReadStatusArgs {
    return new ReadContactReadStatusArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadContactReadStatusArgs {
    return new ReadContactReadStatusArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadContactReadStatusArgs {
    return new ReadContactReadStatusArgs().fromJsonString(jsonString, options);
  }

  static equals(a: ReadContactReadStatusArgs | PlainMessage<ReadContactReadStatusArgs> | undefined, b: ReadContactReadStatusArgs | PlainMessage<ReadContactReadStatusArgs> | undefined): boolean {
    return proto3.util.equals(ReadContactReadStatusArgs, a, b);
  }
}

/**
 * UpdateContactReadStatusArgs メッセージ
 *
 * @generated from message service.UpdateContactReadStatusArgs
 */
export class UpdateContactReadStatusArgs extends Message<UpdateContactReadStatusArgs> {
  /**
   * @generated from field: repeated entity.ContactReadStatus contact_read_statuss = 1 [json_name = "contact_read_statuss"];
   */
  contactReadStatuss: ContactReadStatus[] = [];

  /**
   * @generated from field: bool allow_missing = 2 [json_name = "allow_missing"];
   */
  allowMissing = false;

  /**
   * @generated from field: bool force_execute = 3 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 4 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<UpdateContactReadStatusArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateContactReadStatusArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contact_read_statuss", jsonName: "contact_read_statuss", kind: "message", T: ContactReadStatus, repeated: true },
    { no: 2, name: "allow_missing", jsonName: "allow_missing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateContactReadStatusArgs {
    return new UpdateContactReadStatusArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateContactReadStatusArgs {
    return new UpdateContactReadStatusArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateContactReadStatusArgs {
    return new UpdateContactReadStatusArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateContactReadStatusArgs | PlainMessage<UpdateContactReadStatusArgs> | undefined, b: UpdateContactReadStatusArgs | PlainMessage<UpdateContactReadStatusArgs> | undefined): boolean {
    return proto3.util.equals(UpdateContactReadStatusArgs, a, b);
  }
}

/**
 * DeleteContactReadStatusArgs メッセージ
 *
 * @generated from message service.DeleteContactReadStatusArgs
 */
export class DeleteContactReadStatusArgs extends Message<DeleteContactReadStatusArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  constructor(data?: PartialMessage<DeleteContactReadStatusArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteContactReadStatusArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteContactReadStatusArgs {
    return new DeleteContactReadStatusArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteContactReadStatusArgs {
    return new DeleteContactReadStatusArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteContactReadStatusArgs {
    return new DeleteContactReadStatusArgs().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteContactReadStatusArgs | PlainMessage<DeleteContactReadStatusArgs> | undefined, b: DeleteContactReadStatusArgs | PlainMessage<DeleteContactReadStatusArgs> | undefined): boolean {
    return proto3.util.equals(DeleteContactReadStatusArgs, a, b);
  }
}

/**
 * IndexContactReadStatusReply メッセージ
 *
 * @generated from message service.IndexContactReadStatusReply
 */
export class IndexContactReadStatusReply extends Message<IndexContactReadStatusReply> {
  /**
   * @generated from field: repeated entity.ContactReadStatus contact_read_statuss = 1 [json_name = "contact_read_statuss"];
   */
  contactReadStatuss: ContactReadStatus[] = [];

  constructor(data?: PartialMessage<IndexContactReadStatusReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexContactReadStatusReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contact_read_statuss", jsonName: "contact_read_statuss", kind: "message", T: ContactReadStatus, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexContactReadStatusReply {
    return new IndexContactReadStatusReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexContactReadStatusReply {
    return new IndexContactReadStatusReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexContactReadStatusReply {
    return new IndexContactReadStatusReply().fromJsonString(jsonString, options);
  }

  static equals(a: IndexContactReadStatusReply | PlainMessage<IndexContactReadStatusReply> | undefined, b: IndexContactReadStatusReply | PlainMessage<IndexContactReadStatusReply> | undefined): boolean {
    return proto3.util.equals(IndexContactReadStatusReply, a, b);
  }
}

/**
 * CreateContactReadStatusReply メッセージ
 *
 * @generated from message service.CreateContactReadStatusReply
 */
export class CreateContactReadStatusReply extends Message<CreateContactReadStatusReply> {
  constructor(data?: PartialMessage<CreateContactReadStatusReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateContactReadStatusReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateContactReadStatusReply {
    return new CreateContactReadStatusReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateContactReadStatusReply {
    return new CreateContactReadStatusReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateContactReadStatusReply {
    return new CreateContactReadStatusReply().fromJsonString(jsonString, options);
  }

  static equals(a: CreateContactReadStatusReply | PlainMessage<CreateContactReadStatusReply> | undefined, b: CreateContactReadStatusReply | PlainMessage<CreateContactReadStatusReply> | undefined): boolean {
    return proto3.util.equals(CreateContactReadStatusReply, a, b);
  }
}

/**
 * ReadContactReadStatusReply メッセージ
 *
 * @generated from message service.ReadContactReadStatusReply
 */
export class ReadContactReadStatusReply extends Message<ReadContactReadStatusReply> {
  /**
   * @generated from field: repeated entity.ContactReadStatus contact_read_statuss = 1 [json_name = "contact_read_statuss"];
   */
  contactReadStatuss: ContactReadStatus[] = [];

  constructor(data?: PartialMessage<ReadContactReadStatusReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadContactReadStatusReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contact_read_statuss", jsonName: "contact_read_statuss", kind: "message", T: ContactReadStatus, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadContactReadStatusReply {
    return new ReadContactReadStatusReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadContactReadStatusReply {
    return new ReadContactReadStatusReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadContactReadStatusReply {
    return new ReadContactReadStatusReply().fromJsonString(jsonString, options);
  }

  static equals(a: ReadContactReadStatusReply | PlainMessage<ReadContactReadStatusReply> | undefined, b: ReadContactReadStatusReply | PlainMessage<ReadContactReadStatusReply> | undefined): boolean {
    return proto3.util.equals(ReadContactReadStatusReply, a, b);
  }
}

/**
 * UpdateContactReadStatusReply メッセージ
 *
 * @generated from message service.UpdateContactReadStatusReply
 */
export class UpdateContactReadStatusReply extends Message<UpdateContactReadStatusReply> {
  constructor(data?: PartialMessage<UpdateContactReadStatusReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateContactReadStatusReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateContactReadStatusReply {
    return new UpdateContactReadStatusReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateContactReadStatusReply {
    return new UpdateContactReadStatusReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateContactReadStatusReply {
    return new UpdateContactReadStatusReply().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateContactReadStatusReply | PlainMessage<UpdateContactReadStatusReply> | undefined, b: UpdateContactReadStatusReply | PlainMessage<UpdateContactReadStatusReply> | undefined): boolean {
    return proto3.util.equals(UpdateContactReadStatusReply, a, b);
  }
}

/**
 * DeleteContactReadStatusReply メッセージ
 *
 * @generated from message service.DeleteContactReadStatusReply
 */
export class DeleteContactReadStatusReply extends Message<DeleteContactReadStatusReply> {
  constructor(data?: PartialMessage<DeleteContactReadStatusReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteContactReadStatusReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteContactReadStatusReply {
    return new DeleteContactReadStatusReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteContactReadStatusReply {
    return new DeleteContactReadStatusReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteContactReadStatusReply {
    return new DeleteContactReadStatusReply().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteContactReadStatusReply | PlainMessage<DeleteContactReadStatusReply> | undefined, b: DeleteContactReadStatusReply | PlainMessage<DeleteContactReadStatusReply> | undefined): boolean {
    return proto3.util.equals(DeleteContactReadStatusReply, a, b);
  }
}

